import { LazyImageProp } from '../interface/interface';

function LazyImage(props: Readonly<LazyImageProp>) {
  return (
    <>
      <img
        id={props?.key || '1'}
        src={props.url}
        className={`${props.className}`}
        alt={props.alt}
        loading="lazy"
        onError={(e) => (e.currentTarget.src = '/default-image.png')}
        onClick={(e) => {
          e.stopPropagation();
          props.setOpen(true);
          props.setImageUrl(props.url ?? '/default-image.png');
        }}
      />
    </>
  );
}

export default LazyImage;
